import { decode } from "html-entities";

function parseToText(htmlString: string) {
  // Remove all HTML tags
  let textOnly = htmlString.replace(/<\/?[^>]+(>|$)/g, "");
  return decode(textOnly);
}

export default parseToText;
